export default {
  _Lang: "English",
  MomentLang: "en",

  Account: {
    AccountPermissions: "Account Permissions",
    AllDisabled: "All Disabled",
    AllEnabled: "All Enabled",
    DeleteProfile: "Delete User",
    DeleteUserGroupError: "Delete Group Error",
    EditInformation: "Edit User Details",
    GlobalPreset: "Global Preset",
    GlobalPresetModalMessage:
      "Please confirm you wish to override current settings",
    GlobalPresetWarningMessage:
      "This will update all existing permissions settings.",
    GroupPermissions: "Group Permissions",
    Permissions: "Permissions",
    ResetPassword: "Reset Password",
    ResetPasswords: "Reset Passwords",
    ResetTOTPConfig: "Reset 2FA Config",
    SecurityPolicies: "Security Policies",
    SecurityPolicySettings: {
      AllowPasswordRepeat: "Allow password repeat during expiry reset",
      Basedigits: "Base 10 digits (0-9)",
      Lowercaseletters: "Lower case letters",
      MinimumRequired: "Minimum of three required",
      Minutes: "minutes",
      NotificationExpiryDays: "Notifications expiry (days)",
      NotificationExpirySaved: "Notification expiry saved",
      PasswordExpiry: "Password Expiry (Days)",
      PasswordExpiryPolicy: "Password Expiry Policy",
      PasswordLength: "Password Length (Characters)",
      PasswordLockoutAttempts: "Password Lockout (Attempts)",
      PasswordSettings: "Password Settings",
      PreventCompromised: "Check for compromised",
      PreventPIIData: "Prevent personal data",
      SelectaTime: "Select a time",
      SessionTimeout: "Session timeout",
      SessionTimeoutSaved: "Session timeout has been saved",
      Specialcharacters: "Special characters",
      TwoFA: "Two Factor Authentication",
      TwoFAOptions: {
        Disabled: "Disabled",
        Email: "Enabled - Email code to user",
        TOTP: "Enabled - One-time Password via Authenticator App",
      },
      TwoFACodeLifespan: "Two Factor Authentication Code Lifespan (Minutes)",
      Unicodecharacters: "Unicode characters",
      Update2FAConfig:
        "Two Factor Authentication configuration has been updated.",
      Update2FALifespan:
        "Two Factor Authentication Code Lifespan has been updated.",
      UpdatedPasswordExpiryPolicy: "Password Expiry Policy is updated.",
      Uppercaseletters: "Upper case letters",
    },
    SelectGlobalPreset: "Please select a global preset",
    ThisGroupContainsUsers: "Can not delete the group because it has users",
    UpdatePreset: "Update Presets",
    UserPermissions: "User Permissions",
    ViewRoles: "View Roles",
    Users: {
      AddUserToTheGroup: "Add a user to the group",
      AreYouSuredelete: "Are you sure you want to delete",
      DeleteUser: "Delete User",
      EditDeleteGroup: "Edit or Delete Group",
      EditDeleteUser: "Edit or Delete User",
      EditGroup: "Edit Group",
      LockUser: "Lock User",
      NoUsersSelected: "No users selected",
      Reset2FAConfigurationConfirm: "Please confirm your request",
      Reset2FAConfigurationConfirmation:
        "Are you sure you wish to reset this users 2FA Configuration? The user will be prompted upon next login to reconfigure their Authenticator Application on their mobile device.",
      Reset2FAConfigurationSuccess: "2FA Configuration reset successfully",
      ResetGroupPasswordConfirmation:
        "You wish to force a password reset for the following group:",
      ResetGroupPasswordSuccess: "Password reset successfull",
      ResetPasswordConfirm: "Please confirm your request",
      ResetPasswordConfirmation:
        "You wish to force a password reset for the following user:",
      ResetPasswordSuccess: "Password reset successfully",
      ThisUser: "this user",
    },
    ViewNames: {
      ACCOUNTS: "Accounts",
      ADMIN: "Admin",
      BILLING: "Usage",
      DASHBOARD: "Dashboard",
      DOCUMENTTYPE: "Document Types",
      DOCUMENTUPLOAD: "Document Upload",
      METADATAKEY: "Metadata Keys",
      REASON: "Reasons",
      REPORTS: "Reports",
      RETENTION: "Document Retention",
      ROLES: "Roles",
      SITE_PREFERENCES: "Site Preferences",
      SITEMANAGEMENT: "Folder Management",
      VIEW_DOCUPLOADPPI: "Upload Matching Data",
      WORKFLOW: "Workflow",
      ANNOUNCEMENTS: "Announcements",
    },
  },
  AccountPermissions: {
    EnterNewPasswordFor: "Enter New Password for",
    Modify: "Modify",
    Operations: "Operations",
    ResetPassword: "Reset Password",
    SelectAFolder: "Select a folder",
    View: "View",
  },
  Accounts: "Accounts",
  Action: "Action",
  ActiveAnnouncements: " active announcements",
  ActiveUsers: "Active User Total",
  Add: "Add",
  AddACondition: "Add a condition",
  AddANewMetadataKey: "Add a New Metadata Key",
  AddChild: "Add Child",
  AddComment: "Add Comment",
  AddDocument: "Add Document",
  AddDocumentType: "Add Document Type",
  AddedComment: "Added comment",
  AddNewFolder: "Ajouter un nouveau dossier",
  AdditionalInformation: "Additional Information",
  AdditionalInformationPlaceHolder:
    "Please provide any additional information you want added to the email here.",
  AdditionalOptions: {
    AdditionalOptions: "Additional Options",
    Email: "Include document comments in emailed document",
    Print: "Include document comments in printed document",
  },
  AddNewTextValue: "Add New Text Value",
  AddParentFolder: "Add Parent",
  AdminPages: "Admin Pages",
  Alias: "Alias",
  AllMetadata: "All Metadata",
  Alpha: "Alpha",
  AlreadyExists: "aready exsists",
  Announcements: "Announcements",
  Announcement: {
    BroadcastEndDate: "End Date",
    BroadcastStartDate: "Start Date",
    Create: "Create a new Announcement",
    DeletionConfirmation: "Are you sure you want to delete",
    Empty: "No announcements currently exist",
    Expired: "Expired",
    Expires: "Expires",
    Message: "Content",
    Pending: "Starts",
    Title: "Title",
    Save: "Save",
    SeverityLevel: "Severity",
    Severity: {
      Important: "Important",
      Warning: "Warning",
      Information: "Information",
    },
  },
  Apply: "Apply",
  AreYouSureYouWantReset: "Are you sure you want to reset",
  AssignUpload: "Assign and Upload",
  AssociatedMetadata: "Associated Metadata",
  AtleastLowercase: "At least a lower case character",
  AtleastOneNum: "At least one number",
  AtleastSpecialChar: "At least one special character",
  AtleastUnicodeChar: "At least one unicode character",
  AtleastUppercase: "At least an upper case character",
  AttachFile: "Attach a file",
  Back: "back",
  Background: "Background",
  BetweenChars: (min, max) => `Between ${min} - ${max} characters`,
  Billing: "Usage",
  Bookmark: "Bookmark",
  BookmarkClassification: {
    0: "Personal",
    1: "Published / Shared",
  },
  Bookmarks: "Bookmarks",
  BookmarkTypes: {
    Personal: "Personal",
    SharedPublished: "Published / Shared",
  },
  Boolean: "yes/no",
  BothPasswordsIdentical: "Both the passwords should be identical",
  Browse: "Browse",
  BucketSize: "Storage Total (GB)",
  BulkUploadTitle: "Bulk Upload",
  Cancel: "Cancel",
  CancelPasswordReset: "Cancel Password Reset",
  CancelReset: "Cancel Password Reset",
  CannotCreateThisFolder: "Cannot Create This Folder",
  CardView: "Card View",
  ChangePassword: "Change Password",
  Characters: "characters",
  Choose: "Choose",
  ChooseDate: "Choose Date",
  ChooseDocType: "Choose Document Type",
  ChosenDocType: "Selected Document Type",
  ChooseDocumentType: "Choose Document Type",
  ChooseLocation: "Choose a location",
  ChosenLocation: "Selected Folder",
  Clear: "Clear",
  ClearAll: "Clear all",
  Click: "Click",
  ClickingContinue: "Clicking continue below will redirect you",
  ClientForms: {
    ClientOrder: {
      Fields: {
        accountNumber: "Account Number",
        additionalInformation: "Additional Information",
        addressLine1: "Address Line 1",
        addressLine2: "Address Line 2",
        addressLine3: "Address Line 3",
        authorisedBy: "Authorised By",
        barcode: "Barcode",
        company: "Company",
        contactName: "Contact Name",
        department: "Department",
        destroyDate: "Destroy Date",
        driverInstructions: "Driver Instructions",
        email: "Email",
        name: "Contact Name",
        phone: "Phone",
        postCode: "Post Code",
        size: "Size",
        uniqueId: "Unique Id",
      },
      InfoMessage:
        "Thank you for submitting your form. The below information has been successfully sent to OASIS Group.",
      SubmitForm: "Submit Form",
      Title: "Client Order",
      ValidationMessages: {
        accountNumber: "Account number is required.",
        addressLine1: "Address line 1 is required.",
        addressLine2: "Address line 2 is required.",
        barcode: "Barcode is required.",
        company: "Company is required.",
        contactName: "Contact Name.",
        email: "Email is required.",
        emailFormat: "Email must be a valid email.",
        messageMaxLength10: "Maximum character limit met (10)",
        messageMaxLength20: "Maximum character limit met (20)",
        messageMaxLength40: "Maximum character limit met (40)",
        messageMaxLength80: "Maximum character limit met (80)",
        name: "Contact name is required.",
        phone: "Phone is required.",
        postCode: "Post code is required.",
      },
    },
    ContactClientCare: {
      Fields: {
        description: "Description",
        email: "Email",
        reason: "Reason",
      },
      InfoMessage:
        "Thank you for submitting your form. The below information has been successfully sent to OASIS Group.",
      Title: "Contact Client Care",
      Reasons: [
        "I'd like to send a new item into storage or arrange delivery on an item from storage.",
        "I'd like to update my asset information currently stored on your systems.",
        "I'd like to arrange for one of my assets to be destroyed.",
        "I'd like to arrange secure shredding.",
        "I'd like to discuss setting up or adjusting a scheduled or recurring order.",
        "I'd like to purchase consumable products or materials from OASIS Group.",
        "I'd like to query an order I've already placed.",
        "I have a question in relation to my contract.",
        "I'd like to organise additional training on the ClientHub system.",
        "I'd like to register a new location/office/site with OASIS Group.",
        "I'd like to request a customised report.",
        "I'd like to speak to the Credit Control department.",
        "We're considering leaving OASIS Group and would like to discuss the process.",
        "I'd like to request a copy of a historical invoice.",
        "I'd like to speak to the Billing department.",
        "I have a query regarding pricing.",
        "I'd like to add additional users to our OASIS Group account.",
      ],
      SubmitForm: "Submit Form",
      ValidationMessages: {
        description: "Description is required.",
        email: "Email is required.",
        emailFormat: "Email must be a valid email.",
        messageMaxLength80: "Maximum character limit met (80)",
        reason: "Reason is required.",
      },
    },
    ReturnToClientForms: "Return to Client Forms",
  },
  ClientHub: {
    ClientAccount: "Client Account",
    ClientAccountDetails: {
      AccountName: "Account Name",
      AccountCode: "Client Account Code",
      AccountEmail: "Account Email",
      Industry: "Industry",
      MailingCity: "Mailing City",
      MailingCountry: "Mailing Country",
      MailingPostCode: "Mailing Zip / Postcode",
      MailingStreet: "Mailing Street",
      MailingStateProvince: "Mailing State / Province",
      ReturnToClientAccount: "Return to Client Account",
      Region: "Region",
      SaveAccountDetails: "Save Account Details",
      TelephoneNumber: "Telephone Number",
      ThankYouMessage:
        "Thank you for updating your account details. The below information has been successfully stored.",
      Type: "Type",
    },
    ClientFormsTitle: "Client Forms",
    ClientOrder: "Client Order",
    ContactClientCare: "Contact Client Care",
    ContentsManifest: "Contents Manifest",
    Customer: "Customer",
    CustomFields: "Custom Fields",
    Dashboard: "Dashboard",
    DepartmentName: "Department Name",
    DestructionOverview: "Destruction Overview: Last 6 months",
    Digital: "Digital",
    DigitalStorage: "Digital Storage",
    DigitalStorageUsage: "Digital Storage Usage",
    DownloadResults: "Download Results",
    FormContent: {
      BriefDescriptionOfAnyActionTakenSinceDiscovery:
        "Brief description of any action taken since discovery",
      BriefDescriptionOfAnyActionTakenSinceDiscoveryPlaceholder:
        "Please enter a description of actions taken",
      BriefDescriptionOfBreach: "Brief Description of Breach",
      BriefDescriptionOfBreachPlaceholder:
        "Please enter any important information regarding the possible breach.",
      ContactEmailOfBreachReporter: "Contact Email of Breach Reporter",
      ContactEmailOfIncidentOwner: "Contact Email of Incident Owner",
      ContactNoOfBreachReporter: "Contact No of Breach Reporter",
      ContactNoOfIncidentOwner: "Contact No of Incident Owner",
      DateOfBreach: "Date of Breach",
      DateOfDiscovery: "Date of Discovery",
      LocationAffected: "Location Affected",
      LocationAffectedPlaceholder:
        "Please enter information about the known affected locations.",
      NameOfBreachReporter: "Name of Breach Reporter",
      NameOfIncidentOwner: "Name of Incident Owner",
      NumberOfAffectedSubjects: "Number of affected subjects - if known",
      NumberOfAffectedSubjectsPlaceholder:
        "Please enter a brief description of subjects - if known",
      SubmitReport: "Submit Report",
      TypeOfBreach: "Type of Breach",
    },
    InternalBoxReference: "Internal Box Reference",
    InventoryTotals: "Inventory Totals",
    IssueGettingDataLineOne: "There has been an issue retrieving your data.",
    IssueGettingDataLineTwo:
      "Please contact Client Care if this message persists after refresh",
    ItemCode: "Item Code",
    ItemTypeByStatus: "Item Type by Status",
    NoDataResult: "No Data Results",
    PendingDestruction: "Pending Destruction",
    Physical: "Physical",
    PhysicalRecordBreakdown: "Physical Record Breakdown",
    PhysicalStorage: "Physical Storage",
    ReportBreach: "Report Breach",
    Reports: "Reports",
    SearchOptions: "Search Options",
    SortBy: "Sort by",
    Status: "Status",
    StorageSearch: "Storage Search",
    ViewInOmnidox: "View in Omnidox",
    ViewOnOmnidox: "View on Omnidox",
    WorkOrderSubmission: "Work Order Submission",
    WorkOrderType: "Work Order Type: Last 6 months",
    Year: "Year",
  },
  Close: "Close",
  CollapseAll: "Collapse All",
  ComingSoon: "Coming Soon",
  Comment: "Comment",
  Comments: "Comments",
  Compartment: "Compartment",
  CompartmentsList: "Compartments List",
  Condition: "Condition",
  ConfigureDisplayAmount: "Configure display amount",
  Confirm: "Confirm",
  ConfirmNewPassword: "Confirm New Password",
  ConfirmOldPassword: "Confirm Old Password",
  ContactUs: "Contact Us",
  Continue: "Continue",
  ContinueTo: "Continue to",
  CookieConsent:
    "By using this application you consent to our use of cookies in accordance with our Cookie Policy",
  Create: "Create",
  CreateAFolder: "Create A Folder",
  CreateChild: "Create child",
  CreateChildFolderIn: "Create child folder in",
  CreateDocumentType: "Create Document Type",
  CreateFolder: "Create folder",
  CreateGroups: "Create Groups",
  CreateUsers: "Create Users",
  Dashboard: "Dashboard",
  DataTypeHere: "Data Type Here",
  Date: "Date",
  Day: "Day",
  Days: "Days",
  Decimal: "Decimal",
  Delete: "Delete",
  DeleteComment: "Delete this comment?",
  DeleteConfirm: "Confirm Deletion",
  DeleteData: "Delete document",
  DeletedDocument: "Deleted document",
  DeleteFolder: "Delete folder",
  DeleteInfoMessage: "These records will be removed in 24hrs",
  DeleteNode: "Delete this Node",
  DeleteRecords: "Delete Records",
  Description: "Description",
  DeselectAll: "Deselect All",
  Disabled: "Disabled",
  Document: "Document",
  DocumentActivityHistory: "Document Activity History",
  DocumentExplorer: "Document Explorer",
  DocumentHistoryHeaders: {
    AddedComment: "Added Comment",
    AddedMetadata: "Added Metadata",
    ArchivedDocument: "Marked for Permanent Storage",
    ConvertedAndDownloadedDocument: "Converted and Downloaded Document",
    DeletedComment: "Deleted Comment",
    DeletedDocument: "Deleted Document",
    DocumentMarkedForDestruction:
      "Marked for Destruction after Retention Review",
    DocumentReadiedForRetention: "Document identified for Retention Review",
    DownloadedDocument: "Downloaded Document",
    DownloadedDocumentMetadata: "Downloaded Document Metadata",
    EmailedDocument: "Emailed Document",
    MatchData: "Matched Data",
    MergedAndDownloadedDocument: "Merged and Downloaded Document",
    MovedDocument: "Moved Document",
    PlacedDocumentBackInRetentionReview: "Returned for Retention Review",
    PrintedDocument: "Printed Document",
    RestoredDocument: "Restored from Recycle Bin",
    RetentionReviewPostponed: "Retention Review postponed until ",
    UnMatchData: "Unmatched Data",
    UpdatedComment: "Updated Comment",
    UpdatedMetadata: "Updated Metadata",
    UploadedDocument: "Uploaded Document",
    UpsertCustomerMetadata: "Upsert Customer Metadata",
    ViewedDocument: "Viewed Document",
  },
  DocumentId: "Document ID",
  DocumentIdentifier: "Doc Identifier",
  DocumentName: "Document Name",
  DocumentOpened: "Document opened",
  DocumentPrinted: "Document printed",
  Documents: "Document Type",
  DocumentType: "Document Type",
  DocumentTypeDeleteConfirmMessage: "Please confirm you wish to delete",
  DocumentTypeList: "Document Type List",
  DocumentTypeName: "Document Type Name",
  DocumentTypes: "Document Types",
  DocumentUpload: "Document Upload",
  DocumentView: "Document View",
  Download: "Download",
  Downloading: "Downloading...",
  DownloadOptions: "Download Options",
  DownloadOptionValues: {
    ConvertToPdfAndZip: "Convert to PDF's and Download as Zip",
    StandardDownload: "Download",
    DownloadMetadataAsCSV: "Download Metadata as CSV",
  },
  DownloadUserDetailsAsCSV: "Download User Details as CSV",
  DropItHot: "Drop your files here!",
  DropZoneInitText: "Drag and drop your files here to upload",
  Edit: "Edit",
  EditBookmark: "Edit Bookmark",
  EditDeleteUsers: "Edit or Delete Users",
  EditDocument: "Edit Document",
  EditFolder: "Edit folder",
  EditMetadataKey: "Edit metadata key",
  Email: "Email",
  EmailAddress: "Email address",
  EndDate: "End Date",
  EndDateBeforeStartDateError:
    "End date is before Start date, no results could be found",
  EmailDestinations: "Email Destination(s)",
  EmailDestinationsPlaceHolder: "first@mail.com ; second@mail.com ...",
  EmailSentMessage: "Email has been sent.",
  EmailUnsentMessage:
    "Email could not been sent because the file that you are trying to send is too large. Please try again with a file smaller than 15mb.",
  EnterEmailAddress: "Enter Email address",
  EnterFolderName: "Enter Folder Name",
  EnterNewPassword: "Enter New Password",
  EnterOldPassword: "Enter Old Password",
  EnterTemporaryPassword: "Enter Temporary Password",
  ErrorDocumentView: "There has been an error retrieveing Document View.",
  ExpandAll: "Expand All",
  Expires: "Expires",
  ExportButton: "Export",
  ExportToCsv: "Export to CSV",
  ExporttoCSV: "Export to CSV",
  FieldType: "Field Type",
  File: "File",
  Filename: "Filename",
  FilePreviewErrorForBigFile: "File too large to preview",
  Files: "Files",
  FilesSuccessfullyUploaded: " successfully uploaded",
  FileTooLargePart1: "File exceeds the ",
  FileTooLargePart2: " MB limit.",
  Filters: "Filters",
  FirstSelectDocumentType: "First select a document type",
  Folder: "Folder",
  FolderAndDocTypePermissionError:
    "You need folder and document type permissions.",
  FolderDeleteConfirmMessage: "Please confirm you wish to delete",
  FolderHierarchyTitle: "Folder Hierarchy",
  FolderID: "Folder ID",
  FolderName: "Folder Name",
  Folders: "Folders",
  FolderStructure: "Folder Structure",
  FolderUploadSuccesMessage:
    "Bulk Folder Upload file has been successfully uploaded for processing",
  FooterCopyright: "© " + new Date().getFullYear() + " OASIS Group",
  ForgotPassword: "Forgot password",
  ForgotPasswordModalTitle: "Taking you to OASIS Bridge",
  Forms: {
    AddGroup: "Add Group",
    AddUser: "Add User",
    Department: "Department",
    FirstName: "First Name",
    GroupName: "Group name",
    HasBeenCreated: "has been created",
    LastLogin: "Last Login",
    Location: "Location",
    Mobile: "Mobile",
    MobileNumber: "Mobile Number",
    Surname: "Surname",
  },
  GetBackShortly: "We will get back to you shortly",
  GiveNewName: "Give a new name",
  GlobalSettings: "Global Settings",
  Group: "Group",
  Groups: "Groups",
  GroupAlreadyExists: "Group already exists",
  GroupNameIsRequired: "Group name is required",
  Help: "Help",
  Here: "Here",
  Hidden: "Hidden",
  Hour: "Hour",
  IsClientMetadata: "Is Matching Metadata",
  IsDeleted: "Is Deleted",
  IsSaved: "Is Saved",
  Language: "Language",
  LastModified: "Last Modified",
  LetsTakeStep: "Let's take a step",
  Licenses: "Licenses",
  LicenseHome: "License Home",
  LinkType: "Link Type",
  List: "List",
  Loading: "Loading",
  LoadingDirectories: "Loading directories...",
  Locked: "Locked",
  Login: "Login",
  LoginEmailAddressHint: "Please enter your username or email address",
  LoginErrorMessage: "Login attempt was unsuccessful",
  Logo: "Logo",
  LooksLikeErrorOccurred: "Looks like an Error has occurred!",
  MarkDocumentsForDestruction: "Mark Documents for Destruction",
  markDocumentsForDestruction: "Mark for Permanent Deletion",
  MarkDocumentsrPermanentStorage: "Mark Documents for Permanent Storage",
  MarkedForPermanentDeletion: "Marked for Permanent Deletion",
  MarkForIndefiniteStorage: "Mark for Permanent Storage",
  Match: "Match",
  MatchData: "Match Data",
  MatchDocument: "Match document",
  Matched: "Matched",
  MatchedData: "Matched Data",
  MatchingContent: "Matching Content",
  MatchResults: "Match Results",
  Merge: "Merge",
  Message: "Message",
  MessagePermanentlyDelete: "Please confirm the following",
  Metadata: "Metadata",
  MetadataDataType: "Data Type",
  MetadataDatekey: "Metadata date key",
  MetadataDeleteConfirmMessage: "Please confirm you wish to delete",
  MetadataFilters: "Metadata Filters",
  MetadataKeys: "Metadata Keys",
  MetadataKeyDeleted: "Metadata key successfully deleted",
  MetadataKeyLockedForEditing: "is locked for editing",
  MetadataKeysList: "Metadata Keys List",
  MetadataList: "Metadata List",
  MetadataMandatory: "Is this metadata mandatory?",
  MetadataName: "Metadata name",
  MetadataPrioritiesAreUpdated: "Metadata priorities are updated",
  MinutesAgo: "minutes ago",
  Mobile: "Mobile",
  Month: "Month",
  MonthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  Months: "Months",
  MoveFolder: "Move Folder",
  MultiDocuments: "documents",
  MyDashboard: "My Dashboard",
  MyDocuments: "My Documents",
  Name: "Name",
  Never: "Never",
  New: "New",
  NewAction: "New Action",
  NewCommentAdded: "New comment has been added",
  NewCondition: "New Condition",
  NewFolder: "New folder",
  No: "No",
  NoDocuments: "No Documents",
  NoDocumentsAvailable: "No documents are currently available",
  NoDocumentsFoundInCurrentLocation:
    "No documents are found in the current location.",
  NoDocumentTypes: "No document types",
  NoMetadataDatekeys: "No metadata date keys",
  NoNotificaions: "You have no notifications",
  NoOfActiveDocuments: "Record Total",
  NoResultForRetention:
    "No data result for this selection. Please try enter other values",
  NoResultsForSelection:
    "No data result for this selection. Please try enter other",
  NotAccepted: "File type not accepted, sorry!",
  Notifications: "Notifications",
  NoUsersToShow: "No Users To Show...",
  Number: "Number",
  OfficeDocTooLargeToPreview:
    "Sorry, we are unable to display Microsoft Office documents larger than 20MB!",
  OfficeDocTooLargeToPreviewDownloadInstead:
    "Please download this document instead",
  Omnidox: "Omnidox",
  OnTheLeft: "on the left to find documents",
  OnTheRight: "on the right to select a document to view.",
  OpenedDocument: "Opened document",
  Operand: "Operand",
  Or: "or",
  OtherData: "Other Data",
  Others: "Others",
  Password: "Password",
  PasswordConfirm: "Confirm Password",
  PasswordDosentExist: "This email doesn't exist in our system.",
  PasswordInclude: "Password must include:",
  PasswordMustInclude: "Password must include",
  PasswordProtect: "Password Protect?",
  PasswordReset: "Password Reset",
  PermGroups: {
    Archive: "Archive",
    Comments: "Comments",
    Delete: "Delete",
    Document: "Document",
    DocumentMetadata: "Document & Metadata",
    Documents: "Documents",
    Download: "Download",
    Email: "Email",
    HardDelete: "Hard Delete",
    History: "History",
    Import: "Import",
    LineData: "Line Data",
    Mark: "Mark",
    Match: "Match",
    Move: "Move",
    MoveDocumentTo: "Move Document to",
    MoveDocumentsTo: "Move Documents to",
    Print: "Print",
    Restore: "Restore",
    Revive: "Revive",
    Upload: "Upload",
    ViewAudit: "View Audit",
  },
  PermissionUpdate: "Group permissions are updated",
  PhysicalSearch: {
    Filters: {
      customerFilters: "Customer",
      departmentFilters: "Department",
      fbufIlters: "FBU",
      itemTypeFilters: "Item Type",
      statusFilters: "Status",
    },
  },
  PleaseClickForgotPassword:
    "Please click 'Forgot Password' at the top right of the page to reset your password.",
  PleaseSelect: "Please Select",
  PleaseSelectDataType: "Please Select Data Type",
  PleaseWait: "Please wait...",
  Possible: "possible",
  PostponeDocumentForRetentionReview: "Postpone document for Retention Review",
  PostponeRetentionReview: "Postpone Retention Review",
  PPIFilesSuccessfullyQueued:
    " files sent for processing. You will be notified when complete.",
  PPIFileSuccessfullyQueued:
    " file sent for processing. You will be notified when complete.",
  PreparingFilesForDownload: "Preparing file(s) for download",
  PreparingFilesForPrinting: "Preparing file(s) for printing",
  PreparingFilesForEmailing: "Preparing file(s) for emailing",
  PrintDocument: "Print Document",
  Printing: "Printing...",
  PublicallyVisible: "Public Comment",
  PrivatelyVisible: "Private Comment",
  PrivacyPolicy: "Privacy Policy",
  Profile: "Profile",
  Published: "Published",
  PublicComments: "Include public document comments in downloaded document",
  PrivateComments: "Include private document comments in downloaded document",
  Reasons: {
    AddReason: "Add Reason",
    DocumentOperations: "Document operations",
    EditReason: "Edit reason",
    ExactMatch: "Exact",
    Includes: "Includes",
    IsMandatory: "Is mandatory",
    LinkedOperations: "Linked operations",
    Reason: "Reason",
    ReasonName: "Reason name",
    Reasons: "Reasons",
    ViewAllReasons: "View All Reasons",
    YouHaveNoReasons: "You have no reasons yet",
  },
  RecentlyUploaded: "Recently Uploaded",
  RecyclingBin: {
    Title: "Recycling Bin",
  },
  RedirectedToOASISBridge: "You are being redirected to OASIS Bridge.",
  Remove: "Remove",
  RemoveSortKey: "Remove Sort Key",
  Rename: "Rename",
  RepeatExpiredPasswordNotAllowed: "Repeating expired password is not allowed",
  Reports: {
    ActivityOfAuthorisedUsersWidget:
      "Activity of Authorised Users for a Customer",
    ReportOfCompletedWorkOrderWidget:
      "Completed Work Order Transactions by Service Code",
    ReportOfExpiredItemsReadyForDestructionWidget:
      "Container Expirations Within Selected Date Range",
    ReportOfFileAndItemRetrievalWidget:
      "File/Item Retrievals by Customer Sorted By",
    ReportOfInventoryStatusWidget: "Inventory Status Summary Report",
    ReportOfItemsWithUpcapturedDataWidget: "Items With No Description",
    ReportOfRateCards: "Rate Card",
  },
  Required: "Required",
  Reset: "Reset",
  RestoreBtn: "Restore",
  RestoreRecords: "Restore Records",
  RestoreRecordsForReview: "Restore for Review",
  RestoreTitle: "Restore",
  Retention: {
    AddedMessage: "New retention rule is created.",
    AddRule: "Add rule",
    CreateRetentionTitle: "Create a document retention rule",
    DeleteRuleConfirmMessage: "Are you sure you want to delete",
    DisableRetentionPostponement:
      "Disable postponement ability of documents in Retention Review",
    DocumentRetention: "Document Retention",
    RetentionDuration: "Retention duration",
    RetentionLogic: "Retention logic",
    RuleActive: "Rule active",
    RuleActiveOption: "Is Rule Active?",
    RuleInactive: "Rule inactive",
    RuleDescription: "Rule description",
    RuleDescriptionPlaceholder: "My new retention rule",
    RuleName: "Rule name",
    Save: "Save Settings",
    SelectPeriodOfTime: "Select Period of Time",
    Tab1: "Document Review",
    Tab2: "Marked for Permanent Deletion",
    Tab3: "Marked for Permanent Storage",
    TimePeriod: "Time period",
    UpdatedMessage: "is updated.",
  },
  RetentionReviewPostponeModalText1: "Exclude Document with Id ",
  RetentionReviewPostponeModalText2:
    " from any Retention Rule processing until",
  RetentionReviewPostponeModalText3:
    "Upon clicking Apply, this document will be returned to 'My Documents'",
  RetentionRules: "Retention Rules",
  Role: "Role",
  RoleFeatureAccessSaved: "Feature access updated",
  ROLES: "Roles",
  Roles: {
    AddedRole: "New role is added.",
    AddGroup: "Add Group",
    AddRole: "Save",
    AddToRole: "Add to Role",
    AddUser: "Add User",
    Back: "Back",
    DeleteRole: "Are you sure to delete",
    EditRole: "Save Settings",
    EditTab1: "Basic Settings",
    EditTab2: "Feature Access",
    EditTab3: "Role Assignments",
    GroupList: "Groups",
    HeaderCreateRole: "Create a Role",
    NewAssignment: "New Assignment",
    NoGroupAssigned: "There is no group assignment.",
    NoGroupForAssignmet: "No Groups.",
    NoUserAssigned: "There is no user assignment.",
    NoUserForAssignmet: "No Users.",
    RemoveAssignmet: "Remove",
    RoleDesc: "Description",
    RoleList: "Current Roles",
    RoleName: "Role Name",
    UpdatedRole: "is updated",
    UserList: "Users",
  },
  Save: "Save",
  SaveBookmark: "Save Bookmark",
  SaveDocument: "Save Document",
  SaveToFolder: "Save to folder",
  Search: "Search",
  SearchBin: "Search Bin",
  SearchDocs: "Search documents",
  SearchDocumentRetention: "Search Document Retention",
  SearchFolders: "Search folders",
  SearchMarkedPermanentDeletion: "Search Marked for Permanent Deletion",
  SearchMarkedPermanentStorage: "Search Marked for Permanent Storage",
  SearchResult: "result",
  SearchResults: "results",
  SearchReturned: "returned",
  SelectAll: "Select all",
  SelectCategory: "Please select a category",
  SelectDataType: "Select Data Type",
  SelectDocumentType: "Select Document Type",
  SelectDownloadType: "Select Download Type",
  Selected: "selected",
  SelectFile: "Select File",
  SelectFileText: " Bulk Upload folders by CSV",
  SelectMetadataDatekey: "Select a metadata date key",
  SelectOptions: {
    GeneralEnquiry: "General Enquiry",
    ProductSupport: "Product Support",
    SuggestedImprovements: "Suggested Improvements",
  },
  SelectWorkFlow: "Please select workflow",
  SelectYourFiles: "Select your files",
  Send: "Send",
  SendEmailTitle: "Email your document",
  Settings: "Settings",
  SettingsRezMessage:
    "Omnidox Settings cannot be accessed at this current resolution. Please use a larger window to continue",
  ShowInFolder: "Show In Folder",
  ShowOnList: "Show on Table View",
  SignIn: "Sign in",
  SignInWith: "Sign in with",
  SignOut: "Sign out",
  SingleDocument: "document",
  SiteManagement: "Folder Management",
  SitePreferences: {
    DefaultSearchFilters: "Default Search Filters",
    DefaultSearchFiltersLabels: {
      Comments: "Comments",
      Filename: "Filename",
      MatchingData: "Matched Data",
      Metadata: "Metadata",
      OCR: "OCR",
    },
    DocumentSecurity: "Document Security",
    DocumentSecurityLabels: {
      PasswordProtectBulkActionDownload:
        "Enforce Bulk Action download executions to be password protected",
      PasswordProtectBulkActionDownloadExplanation:
        "Password Protection for Bulk Action downloading has been set as a mandatory requirement by your Site Administrator",
    },
    FolderInheritanceLabel:
      " Child folder is assigned same permissions of its immediate parent when created",
    Folders: "Folders",
    MaxPaginationResults: "Results Per Page",
    MaxSearchResults: "Maximum Search Results",
    PDFLegacyMode: "PDF Legacy Mode",
    PDFLegacyModeLabels: {
      EnablePDFLegacyMode:
        "Enable PDF legacy mode. PDF legacy mode will allow users to circumvent the below features",
      PermissionsCircumvention:
        "- PDF document downloading, printing and emailing only by users with the necessary permissions",
      CapturingReasonsCircumvention:
        "- Capturing reasons for PDF document download, print and email operations",
      DocumentHistoryCircumvention:
        "- PDF document downloading, printing and emailing operations being registered in document history",
    },
    SaveSettings: "Save Settings",
    SearchResults: "Search Results",
    SearchResultLabels: {
      IncludeOcrSearchResultContext:
        "Include a snippet of relevant OCR text matching the users Search Term when using Card View results display",
    },
    SelectDropDownOption: "Select an option",
    Title: "Site Preferences",
  },
  SomethingWrong: "Something went wrong",
  Sort: "Sort",
  SortBy: "Sort By",
  SortFolderWarning:
    "You are about to reorder your folder structure using the Alphabetical Sort By function. This will remove all custom sorting.",
  SortOrder: "Sort order",
  Source: "Source",
  StartDate: "Start Date",
  StaySignedIn: "Stay signed in",
  Subject: "Subject",
  Submit: "Submit",
  SuccessUploaded: "Successfully uploaded",
  TableView: "Table View",
  Telephone: "Telephone",
  TellUsMore: "Click here to tell us more",
  TempPasswordNotReused: "Temporary password may not be reused",
  TermsConditions: "Terms and Conditions",
  Text: "Text",
  Thankyou: "Thank you!",
  ThereAre: "There are ",
  ThisDocumentContainsNoMetadata: "This document contains no metadata",
  ThisFolderContainsFolders:
    "This folder contains folders, please delete child folders first",
  ThisFolderIsEmpty: "This folder is currently empty",
  TimeOut:
    "The background process has timed out and failed. This is usually because the combined size of files to be downloaded is too large.",
  Tip: "Tip",
  Title: "Title",
  ToAddContent: "to add content",
  ToSafety: "to safety",
  Total: "TOTAL",
  TwoFAuth: {
    CancelLogin: "Cancel Login",
    CodeLabelPromptEmail: "Please enter the 6-digit code from your email",
    CodeLabelPromptTOTP:
      "Please enter the 6-digit code from your authenticator app",
    Confirm: "Confirm",
    MessageForEmailCode: "We've sent you an email with a code",
    MessageForTOTPCode: "One-time Password Authentication",
    SidebarMenu: {
      ConfirmationHeader: "Reset Configuration - Are you sure?",
      FollowInstructions: "Follow the below instructions",
      EnterCode: "Please enter the 6-digit code from your device",
      Header: "One-Time Password",
      ManageSettings: "Manage One-time Password Settings",
      QRCodeInstructions:
        "Scan this QR code with your Authenticator app. You will see a 6-digit code appear on your device",
      SecretKeyInstructions:
        "If you can't scan the QR code, please enter this text code manually on your mobile device",
      Success:
        "Two Factor Authentication settings have been successfully saved and verified",
      WarningOne: "Clicking 'Continue' will remove any existing configuration",
      WarningTwo:
        "You must complete all following steps in order to retain access to your account",
      WarningThree:
        "Your previous configuration code will no longer be valid, you should delete any existing configuration from your Authenticator App",
      WarningFour:
        "If you fail to complete all the steps after clicking 'Continue', you will not be able to login and will have to request a Site Administrator to reset your configuration",
    },
  },
  Type: "Type",
  Unknown: "unknown",
  UnauthorizedPage: "Your permissions do not allow you to see this page",
  undefined: "undefined",
  UnmatchData: "Unmatch Data",
  UnsupportedFileSelection: "Unsupported file selected.",
  Updated: "Updated",
  UpdatePriority: "Update Priority",
  UploadDocuments: "Upload Documents",
  UploadedBy: "Uploaded By",
  UploadedDate: "Uploaded Date",
  UploadFiles: "Upload Files",
  Uploading: "Uploading...",
  UploadYourFiles: "Upload your files",
  User: "User",
  UserGroupsList: "User Groups List",
  Username: "Username",
  Users: "Users",
  UseThe: "Use the",
  View: "View",
  ViewDocument: "View Document",
  ViewNewEntries: "View new entries",
  ViewOldEntries: "View old entries",
  ViewPer: "View per",
  Week: "Week",
  Weeks: "Weeks",
  Welcome: "Welcome",
  WelcomeToDocuments: "Welcome to my documents",
  Workflow: {
    Triggers: {
      DocumentAssignedTo: "Document Assigned To",
      DocumentDeleted: "Document Deleted",
      DocumentImported: "Document Imported",
      DocumentMoved: "Document Moved",
      DocumentStatusChanged: "Document Status Changed",
      DocumentUploaded: "Document Uploaded",
      MetadataInserted: "Metadata Inserted",
      MetadataUpdated: "Metadata Updated",
    },
    WorkflowOperand: {
      Between: "Between",
      Contains: "Contains",
      Equal: "Equal",
      GreaterThan: "Greater Than",
      GreaterThanOrEqualTo: "Greater Than Or Equal To",
      LessThan: "Less Than",
      LessThanOrEqualTo: "Less Than Or Equal To",
      None: "None",
      NotEqual: "Not Equal",
    },
  },
  WorkflowList: "Workflow List",
  WorkflowTitle: "Workflow",
  Years: "Years",
  Yes: "Yes",
  YouHaveNoUsersYet: "You have no users yet",
  YourActivityHistoryIsEmpty: "Your activity history is empty",
  YourFileHistoryIsEmpty: "Your file history is empty",
  YourFiles: "your files",

  get Sidebar() {
    return {
      MyDocuments: this.MyDocuments,
      UploadDocuments: this.UploadDocuments,
      Settings: this.Settings,
      RecyclingBin: this.RecyclingBin.Title,
      DocumentRetention: this.Retention.DocumentRetention,
      Notifications: this.Notifications,
      ContactUs: this.ContactUs,
      Profile: this.Profile,

      Dashboard: this.Account.ViewNames.DASHBOARD,
      StorageSearch: "Storage Search",
      Reports: "Reports",
      ClientForms: "Client Forms",
      ClientAccount: "Client Account",
    };
  },

  "too-many-files": "A maximum of 50 documents can be uploaded at one time",
};
